import Icon from '@components/Icon/Icon';
import { AnimatePresence, motion } from 'motion/react';

import styles from '../Field.module.scss';

interface PhoneNumberContentProps {
  number: string;
  extension?: string;
  label?: string;
  size?: 'regular' | 'small' | 'extra-small';
  /** Will default to true. If false, no UI changes upon interaction. */
  interactive?: boolean;
}

const PhoneNumberContent: React.FC<React.PropsWithChildren<PhoneNumberContentProps>> = ({
  number,
  extension,
  label,
  size,
  interactive = true,
}) => {
  return (
    <div className={styles['card-field']} data-size={size}>
      <div className={styles['card-item-icon-circle']} data-is-interactive={interactive} data-size={size}>
        <Icon type={'phone'} className={styles['field-icon']} />
      </div>
      <div className={styles['field-data']}>
        <div className={styles['field-data-value']} data-type="phone">
          <span>{number}</span>
          <AnimatePresence>
            {extension && (
              <motion.small
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 0.15 } }}
                exit={{ opacity: 0, transition: { duration: 0.15 } }}
                className={styles['field-data-subvalue']}
              >
                Ext. {extension}
              </motion.small>
            )}
          </AnimatePresence>
        </div>
        {label && <div className={styles['field-data-label']}>{label}</div>}
        {!label && !number && <div className={styles['field-data-value-placeholder']}>Phone</div>}
      </div>
    </div>
  );
};

export default PhoneNumberContent;
